// Utility functions for device detection and performance optimization
/**
 * Detects if the current device is a mobile device
 * @returns {boolean} True if the device is mobile, false otherwise
 */
export const isMobile = (): boolean => {
  if (typeof window === 'undefined') return false
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ) || window.innerWidth < 768
  )
}
/**
 * Checks if the user prefers reduced motion
 * @returns {boolean} True if the user prefers reduced motion
 */
export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
/**
 * Returns appropriate animation props based on device type
 * @param {Object} desktopProps - Animation props for desktop
 * @param {Object} mobileProps - Animation props for mobile
 * @returns {Object} The appropriate animation props
 */
export const getResponsiveAnimationProps = (
  desktopProps: any,
  mobileProps: any,
): any => {
  return isMobile() ? mobileProps : desktopProps
}
/**
 * Creates a debounced version of a function for mobile devices
 * @param {Function} fn - The function to debounce
 * @param {number} delay - Delay in milliseconds
 * @returns {Function} The debounced function
 */
export const mobileDebounce = (fn: Function, delay: number = 50): Function => {
  let timer: ReturnType<typeof setTimeout>
  return (...args: any[]) => {
    if (isMobile()) {
      clearTimeout(timer)
      timer = setTimeout(() => fn(...args), delay)
    } else {
      fn(...args)
    }
  }
}
